<template>
    <div class="homecontainer container-fluid no-gutters w-container">
        <div class="row row-grid align-items-center">
            <div class="text-center">
                <!--top Image -->
                <figure class="w-100">
                    <img alt="Image placeholder" src="../assets/img/msg/messageTop.jpg" class="img-fluid">
                </figure>
            </div>
        </div>
        <!-- <router-view></router-view> -->

        <div class="row justify-content-center">
            <div class="col-lg-12 mb-3 justify-content-center text-center">
                <h2 class=" mt-4">园区活动</h2>
            </div>
            <!--two Card -->
            <div class="content-container row mt-5 mb-5  justify-content-center">
                <div class="col-5 col-sm-5 col-md-3 no-gutters ">
                    <div class="card-body pb-3 no-gutters">
                        <div class="pt-1" @click="clickCard1">
                            <img src="../assets/img/msg/msg-1.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">第二届520“爱的表白”海峡两崑「中国首饰」设计大赛颁奖典礼＆时尚玉器展</h5>
                        </div>
                    </div>
                </div>

                <div class="col-5  col-sm-5 col-md-3 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 " @click="clickCard2">
                            <img src="../assets/img/msg/msg-2.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2024两岸“青年π”街舞交流赛在宋庄镇大洲玉文化创意园举行</h5>
                        </div>
                    </div>
                </div>

                <div class="col-5 col-sm-5  col-md-3 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 " @click="clickCard3">
                            <img src="../assets/img/msg/msg-3.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">大洲一日研学活动开户！探索艺术之旅一一中国地质大学</h5>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mt-5 mb-5  justify-content-center" >
                <ul class="col-md-9 list-group infinite-list" v-infinite-scroll="load"  style="height: 600px;padding-left: 15px;overflow:auto;">
                <li class="list-group-item border-0" v-for="(item, index) in messageList" :key="index" @click="clickBtn(item)">
                    <div class="row ">
                        <div class='ml-3'>
                            <img :src="item.img" class="img-fluid img-center" style="height: 100px;" alt="Illustration" />
                        </div>
                        <div class='col-8 col-sm-8 col-md-8 pl-3'>
                            <h5 class="h6 mb-1">{{ item.title }} </h5>
                            <h5 class="small mb-1">{{ item.content }}</h5>
                            <small class="mb-1">{{ item.date }} </small>
                        </div>
                    </div>
                </li>

            </ul>
            </div>
            

        </div>
    </div>
</template>

<script>
export default {
    name: 'Message',
    data() {
        return {
            // strwidth:'',
            messageList: [
                {
                    id: '202302',
                    title: '“第二届520“爱的表白”海峡两崑「中国首饰」设计大赛颁奖典礼＆时尚玉器展',
                    img: require("../assets/img/msg/msg-1.jpg"),
                    url: 'https://mp.weixin.qq.com/s/vOcHT4dDPvGS6cIQOLmlXg',
                    content: '备受瞩目的第二届“520”海峡两岸中国首饰设计大赛颁奖典礼在北京大洲玉文化创意园盛大举行。此次活动邀请了北京市台办、北京市台联、通州区台办和宋庄镇政府等各级领导参加。',
                    date: '2024-09-30',
                },
                {
                    id: '202302',
                    title: '2024两岸“青年π”街舞交流赛在宋庄镇大洲玉文化创意园举行',
                    img: require("../assets/img/msg/msg-2.jpg"),
                    url: 'https://mp.weixin.qq.com/s/397UmD-iDCtAMmj9tXbfXQ',
                    content: '在这热情如火的七月，我们在北京市通州区宋庄镇大洲玉文化创意园见证了一场文化与艺术的盛宴——2024两岸“青年π”街舞交流赛。这不仅是一次舞蹈的竞技盛会，更是两岸青年以舞会友、以艺传情的美好时刻。',
                    date: '2024-07-30',
                },
                {
                    id: '202302',
                    title: '大洲一日研学活动开户！探索艺术之旅一一中国地质大学',
                    img: require("../assets/img/msg/msg-3.jpg"),
                    url: 'https://mp.weixin.qq.com/s/2FYZJwVaXXUlRD-o9AQm2g',
                    content: '荷叶罗裙一色裁，芙蓉向脸两边开，盛夏七月，浓荫日长，蔷薇满香，给这炎热的夏带来一抹清凉。作为大洲研学课程项目的开始：中国地质大学研学团来到大洲玉文化创意园踏上了对传统文化深度探索的旅程。',
                    date: '2024-07-12',
                },
                {
                    id: '202302',
                    title: '“表白吧520”海峡两岸中国首饰设计大赛复盘会',
                    img: require("../assets/img/msg/img-5.webp"),
                    url: 'https://mp.weixin.qq.com/s/E9ETQytd9Bjlzs0mXlwTUA',
                    content: '大洲玉文化创意园董事长沈晖携各文化艺术大师针对“表白吧520”海峡两岸中国首饰设计大赛进行复盘会议。',
                    date: '2023-11-10',
                },
            ]
        }
    },
    methods:{
        clickCard1(){
            window.open('https://mp.weixin.qq.com/s/vOcHT4dDPvGS6cIQOLmlXg', '_blank');
        },
        clickCard2(){
            window.open('https://mp.weixin.qq.com/s/397UmD-iDCtAMmj9tXbfXQ', '_blank');
        },
        clickCard3(){
            window.open('https://mp.weixin.qq.com/s/2FYZJwVaXXUlRD-o9AQm2g', '_blank');
        },
        clickBtn(item){
            console.log('clickBtn item:'+item);
            window.open(item.url, '_blank');
            // this.$router.push({
            //     name:'newsDetail',
            //     query:{
            //         path:item.url
            //     }
            // })
        },
        load () {
            //自动加载更多资讯，这里需要调用接口获取更多
            console.log('load');
            // const arr = {
            //         id: '202302',
            //         title: '“表白吧520”海峡两岸中国首饰设计大赛复盘会',
            //         img: require("../assets/img/msg/img-5.webp"),
            //         url: 'https://mp.weixin.qq.com/s/E9ETQytd9Bjlzs0mXlwTUA',
            //         content: '大洲玉文化创意园董事长沈晖携各文化艺术大师针对“表白吧520”海峡两岸中国首饰设计大赛进行复盘会议。',
            //         date: '2023-11-10',
            //     }
            // console.log('arr:'+arr);
            // this.messageList.push(arr)
            // this.messageList.push(arr)
            // this.messageList.push(arr)
            // this.messageList.push(arr)
      }
    },
    mounted() {
        console.log('mounted screen innerWidth:' + window.innerWidth);
        console.log('mounted availWidth‌' + screen.availWidth);
        // this.strwidth = 'innerWidth:' + window.innerWidth
        // this.strwidth = 'availWidth‌:' + screen.availWidth
        // alert(screenwidth)
    },
}
</script>

<style lang="less" >
.lh-130 {
    line-height: 1.3 !important;
}
</style>